/* tslint:disable */
/* eslint-disable */
/**
 * OneAir.AdminPortal
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * 
 * @export
 * @enum {string}
 */
export enum Journey {
    FlightOnly = 'FlightOnly',
    Package = 'Package'
}

export function JourneyFromJSON(json: any): Journey {
    return JourneyFromJSONTyped(json, false);
}

export function JourneyFromJSONTyped(json: any, ignoreDiscriminator: boolean): Journey {
    return json as Journey;
}

export function JourneyToJSON(value?: Journey | null): any {
    return value as any;
}

